import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {workshopRoutes} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {RequiredTestIdProps, composePath, noop, suffixTestId, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

interface ServiceCampaingsHyundaiProps extends RequiredTestIdProps {
  gridCode: 'service-campaign-hyundai' | 'service-campaign-hyundai-unfinished';
}

export function ServiceCampaingsHyundai(props: ServiceCampaingsHyundaiProps) {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    const serviceCampaignId = isArray(rowId) ? rowId[0] : rowId;
    const path = composePath(workshopRoutes.serviceCampaignDetail, {
      params: {
        id: serviceCampaignId,
      },
      queryParams: sourceSearchParams,
      isSearchParamsPreserved: false,
    });

    match(actionKey)
      .with('redirectDetail', 'detail', () => navigate(path))
      .with('redirectDetail_newTab', 'detail_newTab', () => window.open(path))
      .otherwise(noop);
  };

  return (
    <DmsDataGrid
      gridCode={props.gridCode}
      actionCallback={actionCallback}
      data-testid={suffixTestId('service-campaign-hyundai', props)}
    />
  );
}
